<template>
  <el-form :model="form" :rules="rules" ref="form" label-position="top" class="category-attr">
    <template v-if="product_attr_list.length && !formVoid">
      <!-- 7种类型 string select_one select_many integer decimal4 integer_unit decimal4_unit -->
      <template v-for="(item) in product_attr_list">
         <div
          class="attr-item"
          :key="item.name">
          <el-form-item
            :prop="`${item.name}`"
            :label="item.name">
            <el-select
              style="width: 100%"
              v-if="['select_one', 'select_many'].includes(item.typeV2)"
              filterable
              clearable
              :multiple="item.typeV2 === 'select_many'"
              :allow-create="item.appendAllowed"
              :blur-create="item.appendAllowed"
              collapse-tags
              v-model="form[item.name]">
              <el-option
                v-for="(op, opindex) in item.value.split(';')"
                :key="op+opindex"
                :label="op"
                :value="`${op}`"
              ></el-option>
            </el-select>
            <template v-else-if="['integer', 'integer_unit', 'decimal4', 'decimal4_unit'].includes(item.typeV2)">
              <div style="display: flex;">
                <el-input-digit v-model.number="form[item.name]" :precision="['decimal4', 'decimal4_unit'].includes(item.typeV2) ? 4 : 0" clearable allowedNegative />
                <el-select v-if="units[item.name]" v-model="unitsValue[item.name]" style="width: 100px" placeholder="单位">
                  <el-option v-for="v in units[item.name].split(';')" :key="v" :label="v" :value="v"></el-option>
                </el-select>
              </div>
            </template>
            <el-input v-else v-model="form[item.name]" clearable></el-input>
          </el-form-item>
        </div>
      </template>
      
    </template>
    <div v-else>暂无属性</div>
    <template v-if="cid">
      <span class="update-brand">找不到商品属性？
          <el-link :underline="false" @click="fetch_props(true)">刷新数据</el-link>
      </span>
    </template>
  </el-form>
</template>

<script>
import { getCategoryProps } from '@/servers/prod/center/wxh.js'
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash';

export default {
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    values: {
      required: true
    },
    categoryIds: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      form: {},
      formVoid: true,
      product_attr_list: [],
      rules: {},
      categoryIdChange: false,
      categoryId: '',
      cid: '',
      selectManyKeys: [],
      // 需要加上单位
      units: {},
      unitsValue: {},
      // 监听只需要初始赋值
      isInited: false,
      // 同步开关：标识当前是否在根据父级 values 同步本地 form，避免回流
      updatingByValues: false,
    }
  },
  watch: {
    categoryIds: {
      handler(v) {
        this.categoryId = !v.length ? '' : v[v.length - 1]
      },
      immediate: true
    },
    categoryId: {
      handler(v, o) {
        this.product_attr_list = []
        this.rules = {}
        this.categoryIdChange = !!o
        this.cid = v;
        // this.isInited = false;
        v && this.fetch_props()
      },
      immediate: true
    },
    values: {
      immediate: true,
      deep: true,
      handler(v) {
        if (!this.product_attr_list.length) return;
        // 进入父传值→子同步流程，设置保护标记，避免 changeValues 再次向上 emit
        this.updatingByValues = true;

        if (!v || !v.length) {
          this.form = {};
          this.formVoid = true;
          // 同步结束，清除保护标记
          this.$nextTick(() => { this.updatingByValues = false; });
          return;
        }
        // if (this.isInited) return;
        this.formVoid = false;
        v.forEach(item => {
            let av = item.attr_value;
            let ak = item.attr_key;
            if (this.selectManyKeys.includes(ak)) {
              av = Array.isArray(av) ? av : av ? av.split(';') : [];
            } else if (av && ak in this.units) {
              // this.$set(this.unitsValue, ak, av.replace(/\d*/, ''));
              av = parseFloat(av, 10);
            }
            this.$set(this.form, ak, av);
        });
        // 同步结束，清除保护标记
        this.$nextTick(() => { this.updatingByValues = false; });
        // this.isInited = true;
      }
    },
    form: {
      deep: true,
      handler(v) {
        this.changeValues(v);
      }
    },
    unitsValue: {
      deep: true,
      handler() {
        this.changeValues();
      },
    },
  },
  methods: {
    ...mapActions(['updateCatePropShopIndex']),
    init(){
      this.isInited = false;
    },
    async fetch_props(isUpdate) {
        isUpdate && this.updateCatePropShopIndex("wxsph")
        const propConfigs = await getCategoryProps(this.cid);
        this.$emit('props-update', propConfigs)
        if (propConfigs?.attr?.productAttrList?.length) {
            this.product_attr_list = propConfigs?.attr?.productAttrList;
            this.initValues(this.product_attr_list)
        } else {
            return false
        }
    },
    // 初始化类目属性数据结构
    initValues(propConfigs) {
      let init_values = []
      propConfigs?.forEach(item => {
        let isMany = item.typeV2 === 'select_many';
        if (isMany) {
          this.selectManyKeys.push(item.name);
        } else if (['decimal4_unit', 'integer_unit'].includes(item.typeV2)) {
          this.units[item.name] = item.value || '';
          this.$set(this.unitsValue, item.name, item.value ? item.value.split(';')[0] : '')
        }
        let v = {
          attr_key: item.name,
          attr_value: isMany ? [] : ""
        }
        let oldValue = this.values && this.values.find(v => `${v.attr_key}` === `${item.name}`)
        if (oldValue && !this.categoryIdChange) {
          // 老值回显问题
          init_values.push(oldValue)
        } else {
          init_values.push(v)
        }
        this.setRulesByPropConfig(item)
      })
      if (this.categoryIdChange || !(this.values && this.values.length)) {
        this.$emit('change', init_values)
        this.categoryIdChange = false
      } else {
        this.$emit('change', init_values)
      }
    },
    setRulesByPropConfig(config) {
      let rules = []
      if (config.isRequired === 'true') {
        rules.push({ required: true, message: `请完善${config.name}` })
        rules.push({ validator: (rule, value, cb) => {
          if (value) {
            cb()
          } else {
            cb(new Error(`请完善${config.name}`))
          }
        } })
      }
      this.$set(this.rules, config.name, rules)
    },
    changeValues(v = this.form) {
      // 如果当前是父传值触发的本地同步阶段，直接跳过，防止回流
      if (this.updatingByValues) return;

      if (!this.product_attr_list.length) return ;
      let _values = (this.values && this.values.length) ? JSON.parse(JSON.stringify(this.values)) : false
      if (!_values) return;
      _values = _values.map(item => {
          let ak = item.attr_key;
          let av = v[ak] || '';
          if (Array.isArray(av)) {
            av = av.join(';');
          } else if (av && ak in this.units) {
            av += (this.unitsValue[ak] || '');
          }
          return {
              ...item,
              attr_value: av,
          }
      });

      // 等值判断：仅在实际发生变化时才向父级 emit，减少不必要回流
      const prev = JSON.stringify(this.values || []);
      const next = JSON.stringify(_values);
      if (prev !== next) {
        this.$emit('change', _values)
      }
    },
    validate() {
      return new Promise((resolve) => {
          this.$refs.form.validate(valid => {
              resolve(valid);
          })
      })
    },
  }
  
}
</script>

<style lang="scss" scoped>
.category-attr {
  align-items: flex-start;
  position: relative;
  background: #fff !important;
  .attr-item {
    display: flex;
    width: 275px !important;
    margin-bottom: 28px !important;
  }

  ::v-deep .el-form-item__label {
    padding: 0;
  }
  .update-brand {
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
  }
}
</style>